import { useCallback } from 'react'

import { SimpleSelect } from '@workwave-tidal/core/components'
import { timeUtils } from '@/server-data'
import { Tooltip } from '@/components/primitives/Tooltip'

interface Props {
  onChange: (value: uui.domain.client.rm.BarcodePod) => void
  barcodeValue: uui.domain.client.rm.BarcodePod
  options: any[]
  accountPreferences: uui.domain.client.rm.AccountPreferences
  disabled?: boolean
  testId?: string
  isDriverBarcode?: boolean
  driverBarcodeLabel?: string
  driverBarcodeTooltip?: string
}

export function Field(props: Props) {
  const {
    barcodeValue,
    onChange,
    disabled,
    options,
    testId,
    isDriverBarcode,
    accountPreferences,
    driverBarcodeLabel,
    driverBarcodeTooltip,
  } = props

  const handleOnChange = useCallback(
    (item: uui.domain.client.rm.BarcodePod['barcodeStatus']) => {
      onChange({
        ...barcodeValue,
        barcodeStatus: item,
      })
    },
    [onChange, barcodeValue],
  )

  // Format helper text for driver barcodes: "Added from driver • 10:24 AM"
  let helperText: string | undefined
  if (isDriverBarcode && driverBarcodeLabel) {
    const formattedTime =
      barcodeValue.sec > 0
        ? timeUtils.formatSecondsFromMidnight(barcodeValue.sec, accountPreferences.timeFormat)
        : null
    helperText = formattedTime ? `${driverBarcodeLabel} • ${formattedTime}` : driverBarcodeLabel
  }

  const selectComponent = (
    <SimpleSelect
      key={barcodeValue.barcode}
      label={barcodeValue.barcode}
      value={barcodeValue.barcodeStatus}
      onChange={e =>
        handleOnChange(e.target.value as uui.domain.client.rm.BarcodePod['barcodeStatus'])
      }
      disabled={disabled}
      data-testid={testId}
      options={options}
      helperText={helperText}
    />
  )

  // Wrap with tooltip if it's a disabled driver barcode
  if (disabled && isDriverBarcode && driverBarcodeTooltip) {
    return (
      <Tooltip title={driverBarcodeTooltip} placement="top">
        {selectComponent}
      </Tooltip>
    )
  }

  return selectComponent
}
